"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dayjs_1 = __importDefault(require("dayjs"));
var weekOfYear_1 = __importDefault(require("dayjs/plugin/weekOfYear"));
var utils_1 = require("../../../util/utils");
dayjs_1.default.extend(weekOfYear_1.default);
var GanttChartHeaderWeek = function (_a) {
    var week = _a.week;
    var createDays = function () {
        var dayArray = [];
        for (var i = 0; i < 7; i++) {
            var day = week.add(i, 'd');
            dayArray.push(react_1.default.createElement("div", { className: 'gantt-chart-header-week__day', "data-current": utils_1.checkCurrentDay(day), key: week.valueOf() + "_" + i },
                react_1.default.createElement("span", null,
                    day.format('dd'),
                    " ",
                    day.format('DD'))));
        }
        return dayArray;
    };
    var checkSpan = function () {
        if (utils_1.weekEnd(week).month() !== week.month()) {
            return week.format('MMMM') + "/" + utils_1.weekEnd(week).format('MMMM') + " ";
        }
        return week.format('MMMM');
    };
    return (react_1.default.createElement("div", { className: 'gantt-chart-header-week', "data-current": utils_1.checkCurrentWeek(week) },
        react_1.default.createElement("div", { className: 'title' },
            react_1.default.createElement("span", { className: 'title__week' },
                "W",
                week.week()),
            react_1.default.createElement("span", { className: 'title__month' }, checkSpan())),
        react_1.default.createElement("div", { className: 'gantt-chart-header-week__days flex flex-row' }, createDays())));
};
exports.default = GanttChartHeaderWeek;
